<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.5 7.5H8.00006L8 11H8.5" stroke="white" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
    <path
        d="M7.875 5.875C8.22018 5.875 8.5 5.59518 8.5 5.25C8.5 4.90482 8.22018 4.625 7.875 4.625C7.52982 4.625 7.25 4.90482 7.25 5.25C7.25 5.59518 7.52982 5.875 7.875 5.875Z"
        fill="white" />
</svg>